import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool, faUserGraduate, faChalkboardTeacher, faNewspaper } from '@fortawesome/free-solid-svg-icons'

export default function News() {

  useEffect(() => {
    document.title = "Cool Kids English - News"
  }, []);

  return(
    <div>
      <h1>News</h1>
    </div>
  )
}
